import React from 'react';
import Header from "./UI/Header";
import Footer from "./UI/Footer";
import {Outlet} from "react-router-dom";
import {LAYOUT_SHELL_CLASS} from "../util/Constants";

const MainLayout = () => {
    return (
        <div className="flex min-h-screen flex-col bg-cream-50">
            <Header/>
            <main
                className={`flex-1 ${LAYOUT_SHELL_CLASS} pb-8 pt-[calc(4rem+env(safe-area-inset-top,0px))] sm:pb-10 sm:pt-[calc(4.25rem+env(safe-area-inset-top,0px))]`}
            >
                <Outlet/>
            </main>
            <Footer/>
        </div>
    );
};

export default MainLayout;
